import "core-js/modules/es.error.to-string.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import { getBrandToken } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailerToken } from "@faire/help-center-utils/serialized-data/getRetailer";
import { trackCxFoundationsContactusbuttonClick } from "@faire/web-api/events/cxFoundations/click/contactusbutton";
import { StringContextType } from "@faire/web-api/faire/translator/StringContextType";
import { getCurrentPath } from "@faire/web/common/Path";
import { Button } from "@faire/web/slate/Button";
import { ChatBubble } from "@faire/web/slate/icons/foundation/ChatBubble";
import { Spacer } from "@faire/web/slate/spacing";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled from "styled-components";
import { useAIChatbotAccess } from "../hooks/useAIChatbotAccess";
export var ContactUsButton = function ContactUsButton(_ref) {
  var className = _ref.className,
    source = _ref.source,
    variant = _ref.variant,
    style = _ref.style,
    iconDisabled = _ref.iconDisabled;
  var retailerToken = getRetailerToken();
  var brandToken = getBrandToken();
  var _useViewport = useViewport(),
    isMobile = _useViewport.isMobile;
  var hasAIChatbotAccess = useAIChatbotAccess();
  var handleContactUsClick = function handleContactUsClick() {
    trackCxFoundationsContactusbuttonClick(source !== null && source !== void 0 ? source : "", retailerToken !== null && retailerToken !== void 0 ? retailerToken : "", brandToken !== null && brandToken !== void 0 ? brandToken : "");
    if (hasAIChatbotAccess) {
      window.duet.open();
    }
  };
  return /*#__PURE__*/React.createElement(HelpButton, {
    style: style,
    variant: variant !== null && variant !== void 0 ? variant : "primary",
    linkTo: hasAIChatbotAccess ? undefined : getCurrentPath().append({
      contact: "true"
    }).toString(),
    onClick: handleContactUsClick,
    className: className,
    "data-test-id": "contact-us-button"
  }, isMobile || iconDisabled ? null : ( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ChatBubble, {
    color: "inherit",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement(Spacer, {
    width: "1x"
  }))), /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "WnQ/AZ",
    defaultMessage: [{
      "type": 0,
      "value": "Contact opnemen"
    }]
  }));
};
var HelpButton = styled(Button).withConfig({
  displayName: "ContactUsButton__HelpButton"
})(["padding:10px 24px;white-space:nowrap;"]);